import { useCallback, useState, useMemo, useEffect, useRef } from "react"
import { Card } from "antd"
import { mapStatus, getStatusColor } from "../../../utils/mappers"
import { useUser } from "../../../contexts/UserContext"
import { useCards } from "../../../contexts/CardsContext"
import "./SmartCard.css"
import { useTranslation } from "react-i18next"

const NewCard = ({onClick}) => {
    const { getToken, isAdmin, isReadOnly } = useUser()
    const { t } = useTranslation()

    return (
        <Card onClick={onClick} className={"card"} variant="borderless">
            {<div style={{ textAlign: "center", width: "100%", height: "100%", fontSize: "20px" }} >{t('page.newcard.title')}</div>}
        </Card>
    )
}

export default NewCard
